import { ThemeProvider } from '@change/ds-core-ui/next';

import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { EducationModal } from './components/EducationModal';
import { EducationModalHeading } from './components/EducationModalHeading';

export type UseStoriesEducationModalProps = {
	onContinueAction: () => Promise<void>;
	shareVisualPreview: File | string | null;
};

export const useStoriesEducationModal = createModalHook<UseStoriesEducationModalProps, { successfulShare: boolean }>({
	name: 'InstagramStoriesShareEducationModal',
	heading: function EducationModalHead() {
		return (
			<ThemeProvider>
				<EducationModalHeading />
			</ThemeProvider>
		);
	},
	body: function EducationModalBody({ closeModal, options: { onContinueAction, shareVisualPreview } }) {
		return (
			<ThemeProvider>
				<EducationModal
					onContinue={async () => {
						await onContinueAction();
						closeModal({ successfulShare: true });
					}}
					shareVisualPreview={shareVisualPreview}
				/>
			</ThemeProvider>
		);
	},
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-type-assertion
	stylesOverrides: {
		width: '100vw',
		position: 'fixed',
		bottom: 0,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		'& [data-qa="modal-close-button"]': {
			width: 24,
			height: 24,
			top: 24,
			'& svg': {
				width: 24,
				height: 24,
			},
		},
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} as any,
	// if share attempt is done within another modal, we need to kill that modal
	// to avoid multiple layers of modals
	killOpenModal: true,
});
